import React, {useMemo} from "react";
import Uppy from "@uppy/core";
import Webcam from "@uppy/webcam";
import {Dashboard} from "@uppy/react";
import {useRawTranslationObject} from "../../virtual_congress/effects/use_translation";

const UppyFileSelect = ({onFileSelected, translationHtmlContent}) => {
  const uppyLocales = useRawTranslationObject(translationHtmlContent, "photo_booth.uppy.locale") || {}
  const uppyCamTranslation = useRawTranslationObject(translationHtmlContent, "photo_booth.uppy.cam_locale") || {}

  const uppy = useMemo(() => {
    return new Uppy({
      restrictions: {
        maxFileSize: 3000000,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        // allowedFileTypes: ALLOWED_FILE_TYPES
      },
      onBeforeFileAdded: (file) => {
        onFileSelected(file.data)
        return true;
      },
    }).use(Webcam, {
      countdown: false,
      mirror: false,
      showRecordingLength: false,
      preferredVideoMimeType: null,
      preferredImageMimeType: null,
      modes: ['picture'],
      videoConstraints: {
        facingMode: 'user',
        showVideoSourceDropdown: true,
        width: {min: 720, ideal: 1280, max: 1920},
        height: {min: 480, ideal: 800, max: 1080},
      },
      locale: {
        strings: uppyCamTranslation
      },
    })
  }, [])

  return <>
    <Dashboard
      locale={{
        strings: uppyLocales
      }}
      uppy={uppy}
      width={"100%"}
      height={500}
      proudlyDisplayPoweredByUppy={false}
      plugins={['Webcam']}
    />
  </>
}

export default UppyFileSelect